import { Button, Divider, Modal } from 'antd'
import React from 'react'
import newCnh from '../../assets/cnh.png'
import css from './index.scss'

const CnhHelperModal = ({ onCancel, ...props }) => (
  <Modal {...props} width={600} onCancel={onCancel}>
    <img src={newCnh} alt="nova cnh" className={css.image} />
    <div className={css.buttonsWrapper}>
      <Button type="primary" onClick={onCancel}>Fechar</Button>
    </div>
  </Modal>
)

export default CnhHelperModal
